import content from '@/content/project/index'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js